import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Icon } from '@lomarengas/design-system';
import {
  DataTable,
  DataTableItem,
  PaginationComponent,
  SearchBar,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  MunicipalitiesFilter,
  getMunicipalitiesAsync,
  selectMunicipalityItems,
  selectMunicipalityPagination,
  selectMunicipalityItemsLoadingStatus,
} from './municipalitiesSlice';
import { LOADING_STATUS } from '../../common/constants';
import { InitialPaginationParameters } from '../../common/types/pagination.types';

function Municipalities() {
  const dispatch = useAppDispatch();
  const municipalityItems = useAppSelector(selectMunicipalityItems);
  const municipalityItemsPagination = useAppSelector(
    selectMunicipalityPagination,
  );
  const municipalityItemsLoadingStatus = useAppSelector(
    selectMunicipalityItemsLoadingStatus,
  );

  const initialMunicipalitiesFilter: MunicipalitiesFilter = {
    PageNumber: InitialPaginationParameters.PageNumber,
    PageSize: InitialPaginationParameters.PageSize,
    searchString: '',
  };

  const [municipalitiesFilter, setMunicipalitiesFilter] = useState(
    initialMunicipalitiesFilter,
  );

  const [municipalityTableItems, setMunicipalityTableItems] = useState<
    DataTableItem[]
  >([]);

  const handleInputChange = event => {
    const { target } = event;
    const { value, name } = target;
    setMunicipalitiesFilter({ ...municipalitiesFilter, [name]: value });
  };

  const doSearch = () => {
    municipalitiesFilter.PageNumber = InitialPaginationParameters.PageNumber;
    dispatch(getMunicipalitiesAsync(municipalitiesFilter));
  };

  const HandlePaginationClick = (Page: number) => {
    const paginatedFiltering = municipalitiesFilter;
    paginatedFiltering.PageNumber = Page;
    setMunicipalitiesFilter(paginatedFiltering);
    dispatch(getMunicipalitiesAsync(paginatedFiltering));
  };

  useEffect(() => {
    doSearch();
  }, []);

  useEffect(() => {
    if (municipalityItems && municipalityItems.length > 0) {
      const formattedMunicipalityList: DataTableItem[] = [];
      municipalityItems?.forEach(item => {
        formattedMunicipalityList.push({
          ItemId: item.id,
          Items: [item.id, item.name],
          Url: `/locations/municipalities/${item.id}`,
        });
      });
      setMunicipalityTableItems(formattedMunicipalityList);
    }
  }, [municipalityItems]);

  const AddNewButton: JSX.Element = (
    <Link to="/locations/municipalities/addnew" className="btn btn-blue ps-16">
      <Icon CssClass="me-8" AriaLabel="Uusi" Name="plus" />
      Lisää uusi
    </Link>
  );

  return (
    <>
      <Helmet>
        <title>Sijaintitiedot - Kunnat - Haku</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Sijaintitiedot']}
          Children={AddNewButton}
          Title="Kunnat"
        />

        <SearchBar
          FreeTextOnChangeHandler={handleInputChange}
          FreeTextPlaceholder="Hae..."
          SearchHandler={doSearch}
          IsLoading={municipalityItemsLoadingStatus !== LOADING_STATUS.IDLE}
          Value={municipalitiesFilter.searchString}
        />

        {municipalityItemsLoadingStatus === LOADING_STATUS.IDLE &&
          municipalityItems !== null &&
          municipalityItems.length > 0 && (
            <>
              <DataTable
                ColumnWidths={[400, null]}
                Header={['Kunnan ID', 'Kunnan nimi']}
                Items={municipalityTableItems}
                LegendText="kuntaa"
                TotalItems={municipalityItemsPagination.totalCount}
              />
              <PaginationComponent
                OnPageClick={HandlePaginationClick}
                PaginationData={municipalityItemsPagination}
              />
            </>
          )}

        {municipalityItemsLoadingStatus === LOADING_STATUS.IDLE &&
          municipalityItems != null &&
          municipalityItems.length < 1 && (
            <p>Ei kuntia annetuilla hakuehdoilla.</p>
          )}
      </Container>
    </>
  );
}

export default Municipalities;
